export default "__VITE_ASSET__BBfDi4zf__"